module.exports = __webpack_public_path__ + "img/logo-trespa-black.b7d882f1.png";